import { useEffect, useState } from "react";
import { CheckTest, PopupResult, QuestionCard } from "../styles/TestCard.Main";
import { MTButton } from "../../../components/button/MTButton";
import RiskPlanList from "./Risk_Plan_List";
import { ICON_INFO } from "../../../utils/useIcons";

const ViewDisabledCase = ({ formRisk, setFormRisk, setMenu, setRiskData }) => {
  const [openResult, setOpenResult] = useState(false);

  //---------- ข้อหนึ่ง ----------//
  const onChangeDisableLevelPassAway = (e) => {
    let value = e.target.value;
    if (value === "high") {
      setFormRisk({
        ...formRisk,
        disable_level_pass_away_high: true,
        disable_level_pass_away_medium: false,
        disable_level_pass_away_low: false,
      });
    } else if (value === "medium") {
      setFormRisk({
        ...formRisk,
        disable_level_pass_away_high: false,
        disable_level_pass_away_medium: true,
        disable_level_pass_away_low: false,
      });
    } else {
      setFormRisk({
        ...formRisk,
        disable_level_pass_away_high: false,
        disable_level_pass_away_medium: false,
        disable_level_pass_away_low: true,
      });
    }
  };

  //---------- ข้อสอง ----------//
  const onChangeDisablePassAwayYesterday = (e) => {
    let value = e.target.value;
    if (value === "high") {
      setFormRisk({
        ...formRisk,
        disable_pass_away_yesterday_high: true,
        disable_pass_away_yesterday_medium: false,
        disable_pass_away_yesterday_low: false,
      });
    } else if (value === "medium") {
      setFormRisk({
        ...formRisk,
        disable_pass_away_yesterday_high: false,
        disable_pass_away_yesterday_medium: true,
        disable_pass_away_yesterday_low: false,
      });
    } else {
      setFormRisk({
        ...formRisk,
        disable_pass_away_yesterday_high: false,
        disable_pass_away_yesterday_medium: false,
        disable_pass_away_yesterday_low: true,
      });
    }
  };

  //---------- ข้อสาม ----------//
  const onChangeDisableManageRisk = (e) => {
    let value = e.target.value;
    if (value === "avoid") {
      setFormRisk({
        ...formRisk,
        disable_manage_risk_avoidance: true,
        disable_manage_risk_control: false,
        disable_manage_risk_accept: false,
        disable_manage_risk_transfer: false,
      });
    } else if (value === "control") {
      setFormRisk({
        ...formRisk,
        disable_manage_risk_avoidance: false,
        disable_manage_risk_control: true,
        disable_manage_risk_accept: false,
        disable_manage_risk_transfer: false,
      });
    } else if (value === "accept") {
      setFormRisk({
        ...formRisk,
        disable_manage_risk_avoidance: false,
        disable_manage_risk_control: false,
        disable_manage_risk_accept: true,
        disable_manage_risk_transfer: false,
      });
    } else {
      setFormRisk({
        ...formRisk,
        disable_manage_risk_avoidance: false,
        disable_manage_risk_control: false,
        disable_manage_risk_accept: false,
        disable_manage_risk_transfer: true,
      });
    }
  };

  //---------------------------//

  const getSum = () => {
    let sumScore = 0;
    if (formRisk?.disable_pass_away_yesterday_high) {
      sumScore += 1;
    }
    if (formRisk?.disable_pass_away_yesterday_medium) {
      sumScore += 1;
    }
    if (formRisk?.disable_manage_risk_avoidance) {
      sumScore += 1;
    }
    if (formRisk?.disable_manage_risk_control) {
      sumScore += 1;
    }
    if (formRisk?.disable_manage_risk_accept) {
      sumScore += 1;
    }
    if (formRisk?.disable_manage_risk_transfer) {
      sumScore += 1.5;
    }

    return sumScore;
  };

  useEffect(() => {
    setFormRisk({
      ...formRisk,
      disable_sum_score: getSum(),
    });
    setRiskData({
      ...formRisk,
      disable_sum_score: getSum(),
    });
  }, [getSum()]);

  useEffect(() => {
    if (openResult) {
      document?.getElementById("result_disable")?.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    }
  }, [openResult]);

  const onClickSubmit = () => {
    setOpenResult(!openResult);
  };

  // console.log("formRisk : ", formRisk);
  // console.log("sumScore -----------------> ", getSum());

  return (
    <div className="mt-[14px] px-[25px]">
      <div className=" flex flex-col justify-center items-center gap-1">
        <img src="/images/risk_diabled.svg" className=" w-[50px] h-[50px]" />
        <div className=" text-center text-black font-semibold ">
          กรณีทุพพลภาพ
        </div>
      </div>

      <div className=" flex flex-col gap-4 mt-[14px]">
        <QuestionCard
          name="one"
          checkedHigh={formRisk?.disable_level_pass_away_high}
          checkedMedium={formRisk?.disable_level_pass_away_medium}
          checkedLow={formRisk?.disable_level_pass_away_low}
          formRisk={formRisk}
          onChange={onChangeDisableLevelPassAway}
          question="1. ท่านคิดว่าโอกาสการเกิดทุพพลภาพท่านอยู่ในระดับใด  "
          choice1={`สูง`}
          choice2={`กลาง`}
          choice3={`ต่ำ`}
        />
        <QuestionCard
          name="two"
          checkedHigh={formRisk?.disable_pass_away_yesterday_high}
          checkedMedium={formRisk?.disable_pass_away_yesterday_medium}
          checkedLow={formRisk?.disable_pass_away_yesterday_low}
          formRisk={formRisk}
          onChange={onChangeDisablePassAwayYesterday}
          question="2. ถ้าเมื่อวานท่านเกิดเหตุทุพพลภาพถาวร
          เนื่องจากเจ็บป่วยหรืออุบัติเหตุจะมีผลกระทบการเงินกับครอบครัวในระดับใด"
          choice1={`สูง`}
          choice2={`กลาง`}
          choice3={`ต่ำ`}
        />
        <QuestionCard
          name="three"
          checkedAvoidance={formRisk?.disable_manage_risk_avoidance}
          checkedControl={formRisk?.disable_manage_risk_control}
          checkedAccept={formRisk?.disable_manage_risk_accept}
          checkedTransfer={formRisk?.disable_manage_risk_transfer}
          formRisk={formRisk}
          onChange={onChangeDisableManageRisk}
          position={"verticle"}
          question={
            <div className="flex gap-1.5">
              3. ท่านมีวิธีการในการจัดการความเสี่ยงกรณีทุพพลภาพในปัจจุบันอย่างไร
              <a href="https://www.youtube.com/watch?v=PlqpT01BoIk">
                <ICON_INFO className={`flex-none text-gray90 w-6 h-6`} />
              </a>
            </div>
          }
          choice1={`หลีกเลี่ยงความเสี่ยง`}
          choice2={`ควบคุมความเสี่ยง`}
          choice3={`รับความเสี่ยง`}
          choice4={`โอนความเสี่ยง`}
        />
      </div>

      <div className="flex justify-center my-6">
        <MTButton
          text="แสดงผลลัพธ์"
          // loading={loading}
          onClick={onClickSubmit}
        />
      </div>

      {openResult && (
        <div className="flex flex-col">
          <div className=" text-mainblue font-semibold text-center mt-6 mb-4 ">
            ผลลัพธ์วางแผนกรณีทุพพลภาพ
          </div>

          {formRisk?.disable_sum_score === 1 && (
            <PopupResult
              img="/images/good1.png"
              classNameImg={`h-[52px] mt-[7px]`}
              text={`ท่านมีความสามารถในการรับ`}
              text2={`ความเสี่ยงไว้เองได้`}
            />
          )}

          {formRisk?.disable_sum_score === 1.5 && (
            <PopupResult
              img="/images/good2.png"
              classNameImg={`h-[52px] mt-[7px]`}
              text={`'โอนความเสี่ยง' ท่านเลือกวิธีจัดการความเสี่ยง`}
              text2={`ได้เหมาะสมท่านมีความสามารถในการรับ`}
              text3={`ความเสี่ยงไว้เองได้`}
            />
          )}

          {formRisk?.disable_sum_score === 2 && (
            <PopupResult
              img="/images/wheelchair.png"
              classNameImg={`h-[52px] mt-[7px]`}
              text={`แนะนำให้ท่านโอนความเสี่ยง`}
              text2={`ด้วยการทำประกันทุพพลภาพ`}
            />
          )}

          {formRisk?.disable_sum_score === 2.5 && (
            <PopupResult
              img="/images/good_wheelchair.png"
              classNameImg={`h-[52px] mt-[7px]`}
              text={`'โอนความเสี่ยง' ท่านเลือกวิธีจัดการความเสี่ยง`}
              text2={`ได้เหมาะสม แนะนำให้ท่านโอนความเสี่ยง`}
              text3={`ด้วยการทำประกันการทุพพลภาพ`}
            />
          )}

          <div className=" mt-6">
            <div className=" text-black text-center font-medium">
              แบบทดสอบวิธีจัดการความเสี่ยงของท่าน
            </div>
            <RiskPlanList formRisk={formRisk} setMenu={setMenu} />
          </div>
        </div>
      )}
      <div className="mt-6" id="result_disable"></div>
    </div>
  );
};
export default ViewDisabledCase;
